// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","wrapper":"Footer_wrapper__RAsdB","logos":"Footer_logos__UDfPS","grid":"Footer_grid__PLkkK"};